import React from 'react';
import { Truck, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_c3e4d1ad-70cf-4f68-ba19-cd50fce4c8ed/artifacts/brtpycnt_MaheshXpress_Logo.png"
                alt="MAHESHXPRESS Logo"
                className="h-12 w-auto bg-white p-2 rounded"
              />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              <span className="text-red-500 font-bold">MAHESH</span>
              <span className="text-yellow-500 font-bold">XPRESS</span> - Your trusted logistics partner. 
              Delivering Trust, Mile After Mile across Maharashtra.
            </p>
            <div className="flex items-center space-x-2 text-gray-400">
              <Truck className="w-5 h-5" />
              <span className="text-sm">Specialists in Mumbai to Chakan Routes</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-red-500 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#why-choose-us" className="text-gray-400 hover:text-red-500 transition-colors">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#routes" className="text-gray-400 hover:text-red-500 transition-colors">
                  Routes
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-red-500 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:9967331255" className="text-gray-400 hover:text-red-500 transition-colors">
                    +91 99673 31255
                  </a>
                  <p className="text-xs text-gray-500">Available 24/7</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div>
                  <span className="text-gray-400">Mumbai, Navi Mumbai</span>
                  <p className="text-xs text-gray-500">Maharashtra, India</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} <span className="text-red-500 font-semibold">MAHESH</span>
              <span className="text-yellow-500 font-semibold">XPRESS</span>. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Delivering Trust, Mile After Mile
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;